module.exports = __webpack_public_path__ + "static/HowItWorksTechnology-4bed7bb22d3475d21123ef9b8b138565.svg";